import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

// The avatar of an actor list item: the arrow is centered on its column.
const AVATAR_SIZE_PX = 40;

// The quotation goes from its emitter, listed above, to its receiver, listed
// below: a straight arrow down the column of their avatars links them.
export const QuotationFlowArrow = () => (
  <ListItem aria-label="Devis émis vers" sx={{ py: 0 }}>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: AVATAR_SIZE_PX,
      }}
    >
      <ArrowDownwardIcon color="action" fontSize="small" />
    </Box>
  </ListItem>
);
